import qs from 'qs'
import axios from 'axios'
import config from './config.js';
import { Toast } from 'vant';

// create an axios instance
console.log(config.api, '接口api')
const instance = axios.create({
  baseURL: config.api,
  timeout: 50 * 1000 // request timeout
})

const needQsMethods = ['get', 'delete', 'head', 'options']

const Token = localStorage.getItem('token');
/**
 * 请求拦截器
 */
instance.interceptors.request.use(
  (config) => {
	  // console.log(config, '请求数据')
    const status = needQsMethods.includes(config.method)
    if (status) { // 需要进行 qs 序列化
      config.paramsSerializer = params => qs.stringify(params,{ indices: false })
    }
    if (Token) {
      config.headers['token'] = toKey;
    }
    if (config.isForm) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
    } else if (config.isUpload) {
      config.headers['Content-Type'] = 'multipart/form-data'
    } else {
      config.headers['Content-Type'] = 'application/json; charset=UTF-8'
    }
	
    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

/**
 * 响应拦截器
 */
instance.interceptors.response.use(
  // 响应成功，
  (response) => {
	  // console.log(response, '响应数据')
    const { isDownload } = response.config
    if (isDownload) return Promise.resolve(response)
    else return handleResponse(response,response.config)
  },
  // 响应失败
  (error) => {
    const {response, message} = error;
    if (message.includes('timeout')) {
      Toast('请求超时')
      return Promise.reject(error)
    } else if (error && error.__CANCEL__) {
      Toast('当前请求已取消，请稍后再试!')
    } else if (message === 'Network Error') {
      Toast('网络错误')
    } else if (response.data) {
      Toast(response.data?.message)
    } else {
      // Toast('当前网络异常，请稍后再试!')
      handleError(response)
    }

    return Promise.reject(error)
  }
)

// 处理响应成功数据
function handleResponse(response) {
  const res = response.data;
  
  switch (res.code) {
    case 200:
      return Promise.resolve(res)
    case 401:
		// 未登录
      break
    case 403:
	
      return Promise.reject(new Error(res.msg || 'Response Error'))
    case 1004:
		// 刷新token
    default:
	  Toast(res.msg)
      return Promise.reject(new Error(res.msg || 'Response Error'))
  }
}

// 根据响应失败，对浏览器响应状态码处理
function handleError(response) {
  let msg = ''
  const {status} = response
  switch (status) {
    case 403:
      msg = '权限不足，拒绝访问'
      break
    case 404:
      msg = '404 资源不存在'
      break
    case 500:
      msg = '服务器错误'
      break
    default:
      break
  }
  Toast(msg)
}

export default instance
